/* eslint-disable react-hooks/rules-of-hooks */
import React, {useContext, useEffect, useState} from 'react';
import {AddCoaches, EditCoaches} from '..';
import {Admin, Teams} from '../../../utils/api';
import {DeleteContainer} from '../ManagePlayers/styles';
import {ARMcontext} from '../../../utils/context/context';
import {useInputValue} from '../../../utils/hooks/useInputValue';
import {ManageHeaderContent, ManageHeaderLeft, ManageHeaderWrapper} from './styles';
import {
  InfoBanner,
  InputComponent,
  PowerDropdown,
  WhiteContainer,
  TableManage,
  Modal,
  NavbarButton,
  LargeButton,
  Loader,
} from '../../../components';

const DefaultCoaches = [
  {title: 'All Coaches', lenght: 0},
  {title: 'Coach', lenght: 0},
  {title: 'Admin', lenght: 0},
];

const coachTableHead = [
  {
    title: 'COACH',
    colSpan: '1',
    examType: ['firstName'],
  },
  {
    title: 'EMAIL',
    colSpan: '1',
    examType: ['email'],
  },
  {
    title: 'ROLE',
    colSpan: '1',
    examType: ['role'],
  },
  {
    title: 'TEAM ACCESS',
    colSpan: '1',
    examType: ['teams', 0, 'name'],
  },
  {
    title: 'STATUS',
    colSpan: '1',
    examType: ['status'],
  },
  {
    title: 'LAST LOGIN',
    colSpan: '1',
    examType: ['lastLogin'],
  },
  {
    title: 'INVITATION SENT',
    colSpan: '1',
    examType: ['createdAt'],
  },
];

export default ({teamMemo, modal, useModal}) => {
  const [coachInvitations, useCoachInvitations] = useState<Array<object | any> | any>([]);
  const [selectedCoaches, useSelectedCoaches] = useState<Array<object | any> | any>([]);
  const [defaultCoaches, useDefaultCoaches] = useState<Array<any>>(DefaultCoaches);
  const [coachCountInfo, useCoachInfo] = useState<Array<object | any> | any>([]);
  const [coaches, useCoaches] = useState<any>(DefaultCoaches[0]);
  const {HandleToastMessage} = useContext(ARMcontext);
  const [team, useTeam] = useState<any>(teamMemo[0]);
  const [counter, useCounter] = useState<number>(0);
  const filterCoach = useInputValue('', 'search');
  const [loading, useLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(true);
  const [remove, useRemove] = useState(false);
  const [check, useCheck] = useState(false);
  const [edit, useEdit] = useState(false);
  const ADMIN = new Admin();
  const TEAMS = new Teams();

  useEffect(() => {
    FetchCoachInvitation();
    useTeam(prev => {
      prev.name = 'All Teams';
      return prev;
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    useCounter(coachInvitations.reduce((total, el) => (el.checked ? total + 1 : total), 0));
    BuildCoachFilter();
    // eslint-disable-next-line
  }, [coachInvitations]);

  const DefaultInfo = [
    {number: coachCountInfo.admins, text: 'Admins'},
    {number: coachCountInfo.coachs, text: 'Coaches'},
  ];
  function checkTeams(team, teams): Boolean {
    let isInMyTeam: Boolean = false;
    teams.map(item => {
      if (item._id === team) {
        isInMyTeam = true;
      }
      return true;
    });
    return isInMyTeam;
  }
  function BuildCoachFilter(selectedTeam = undefined) {
    const filteredCoaches = coachInvitations.filter(el => {
      if (!Boolean(selectedTeam)) {
        return true;
      } else return checkTeams(selectedTeam, el?.teams);
    });

    const coach = filteredCoaches.reduce((total, el) => (el.role === 'Coach' ? total + 1 : total), 0);
    const admin = filteredCoaches.reduce((total, el) => (el.role === 'Admin' ? total + 1 : total), 0);
    const coachCounts = [
      {title: 'All Coaches', lenght: filteredCoaches.length.toString()},
      {title: 'Coach', lenght: coach.toString()},
      {title: 'Admin', lenght: admin.toString()},
    ];
    useDefaultCoaches(coachCounts);
    useCoaches(coachCounts[0]);
  }

  function ChangeTeam(selectedTeam: any) {
    useTeam(selectedTeam);
    BuildCoachFilter(selectedTeam._id);
  }

  function ChangeCoaches(selectedOption: any) {
    useCoaches(selectedOption);
  }

  async function FetchCoachInvitation(): Promise<void> {
    const resCoachInvitation = await ADMIN.GetAdminCoachInvitation();
    if(resCoachInvitation.status){
      useCoachInvitations(resCoachInvitation.data.response);
      useCoachInfo(resCoachInvitation.data.dataCount);
    }else{
      HandleToastMessage(resCoachInvitation?.data?.message || 'Server error', true, 2000, 'error');
    }
    setLoadingTable(false);
  }

  function HandleAddCoach(value = true) {
    useModal(value);
    if (!value) {
      FetchCoachInvitation();
    }
  }

  function HandleRemove(value = true) {
    useRemove(value);
    useSelectedCoaches(JSON.parse(JSON.stringify(coachInvitations.filter(el => el['checked']))));

    if (!value) {
      FetchCoachInvitation();
    }
  }

  function HandleOneCoach(check: any) {
    useCoachInvitations([
      ...coachInvitations.map(el => {
        if (check._id === el._id) {
          el['checked'] = !el?.checked || false;
        }
        return el;
      }),
    ]);
  }

  function HandleAllCoach(check: any) {
    useCheck(check);
    useCoachInvitations([
      ...coachInvitations.map(el => {
        if (!Boolean(team._id)) {
          el['checked'] = check;
        } else if (checkTeams(team._id, el?.teams)) {
          el['checked'] = check;
        }

        return el;
      }),
    ]);
  }

  function HandleEdit(value = true) {
    useEdit(value);
    useSelectedCoaches(JSON.parse(JSON.stringify(coachInvitations.filter(el => el['checked']))));
    if (!value) {
      FetchCoachInvitation();
    }
  }

  function RemoveCoaches() {
    useLoading(true);
    const coachIDs = selectedCoaches.map(el => el._id);
    const results = coachIDs.map(async el => {
      return await TEAMS.DeleteCoachInvitation(el);
    });
    Promise.all(results).then(() => {
      HandleToastMessage('Invitations deleted', true, 2500, 'success');
      HandleRemove(false);
      useLoading(false);
    });
  }
  return (
    <>
      <WhiteContainer dataCy="ManageCoaches-container">
        {!Boolean(counter) ? (
          <ManageHeaderContent>
            <ManageHeaderLeft>
              <ManageHeaderWrapper>
                <PowerDropdown
                  primaryTitle={team.name}
                  badge={team?.initials || team.badge}
                  picture={team.picture}
                  colorBadge={team.color}
                  search={true}
                  onClick={ChangeTeam}
                  dataArray={teamMemo.map((el, idx) => {
                    if (idx === 0) el.name = 'All Teams';
                    return el;
                  })}
                  mPadding="4px 0 4px 10px"
                  mWidth="308px"
                />
              </ManageHeaderWrapper>
              <ManageHeaderWrapper data-cy="ManageCoaches-container-players">
                <PowerDropdown
                  primaryTitle={coaches.title}
                  visibleLenght={coaches.lenght}
                  search={false}
                  onClick={ChangeCoaches}
                  dataArray={defaultCoaches}
                  mPadding="4px 0 4px 10px"
                />
              </ManageHeaderWrapper>
              <ManageHeaderWrapper>
                <InputComponent responsive="700px" dynamicSearch={filterCoach} animateWidth="80%" placeholder="Search coaches" />
              </ManageHeaderWrapper>
            </ManageHeaderLeft>

            <InfoBanner data={DefaultInfo} />
          </ManageHeaderContent>
        ) : (
          <ManageHeaderContent data-cy="manageCoaches-counter-container">
            <ManageHeaderLeft>
              <NavbarButton xmargin="4px" counter={counter} title="" icon="checkbox" onClick={() => HandleAllCoach(false)} />
              <NavbarButton xmargin="4px" text="Edit coach" title="" icon="save" onClick={HandleEdit} />
              <NavbarButton xmargin="4px" text="Remove" title="" icon="trash" onClick={HandleRemove} />
            </ManageHeaderLeft>
          </ManageHeaderContent>
        )}

        <div style={{overflowX: 'auto'}}>
          {
            loadingTable ? (
              <Loader height="90px" />
            ) : (
              <TableManage
                minWidth="800px"
                dataTableHead={coachTableHead}
                dataMainHead={[]}
                dataTableContent={coachInvitations}
                filter={filterCoach}
                HandleOne={HandleOneCoach}
                HandleAll={HandleAllCoach}
                typeOfTable={1}
                individualFilter={coaches}
                selectedTeam={team._id}
                check={check}
              />
            )
          }
        </div>
      </WhiteContainer>
      {modal && (
        <Modal title="Add Coaches" margin="10vh auto 200px auto" dataCy="addCoaches-modal">
          <AddCoaches handleView={HandleAddCoach} teamMemo={teamMemo} />
        </Modal>
      )}
      {remove && (
        <Modal title="Delete" subtitle="Do you want to permanently delete the selected items?" margin="30vh auto 200px auto">
          <DeleteContainer>
            <LargeButton
              callback={() => HandleRemove(false)}
              rColor="#ffffff"
              lColor="#ffffff"
              title="CANCEL"
              fColor="#5D6C76"
              bColor="#F0F0F0"
              lMargin="0"
              xMargin="0 10px 0 0"
            />
            {loading ? (
              <Loader width="130px" />
            ) : (
              <LargeButton callback={RemoveCoaches} rColor="#FF3B30" lColor="#E1342A" icon="trash" title="DELETE" />
            )}
          </DeleteContainer>
        </Modal>
      )}
      {edit && (
        <Modal title="Edit Coaches" margin="10vh auto 200px auto" dataCy="editCoaches-modal">
          <EditCoaches
            teamMemo={teamMemo}
            handleView={HandleEdit}
            selectedCoaches={selectedCoaches}
            useSelectedCoaches={useSelectedCoaches}
          />
        </Modal>
      )}
    </>
  );
};
